import { USE_LOCAL_FALLBACK } from "../config/firebaseConfig";
import { db } from "../services/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

// #region debug-point A:sections-service-logger
const dbg = (hypothesisId, msg, data = {}) => fetch("http://127.0.0.1:7777/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sessionId: "sections-save-permissions", runId: "pre-fix", hypothesisId, location: "src/services/sectionsService.js", msg: `[DEBUG] ${msg}`, data, ts: Date.now() }) }).catch(() => {});
// #endregion

export async function loadGradeSections(campus) {
  const campusLC = String(campus || "").toLowerCase();
  if (!campusLC) return {};
  if (USE_LOCAL_FALLBACK) {
    try {
      const raw = localStorage.getItem("gradeSections");
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }
  try {
    const snap = await getDoc(doc(db, "gradeSections", campusLC));
    const data = snap.exists() ? snap.data() : null;
    const map = (data && data.map) ? data.map : {};
    try {
      localStorage.setItem(`gradeSections_cache_${campusLC}`, JSON.stringify(map));
    } catch { /* ignore */ }
    return map || {};
  } catch {
    try {
      const raw = localStorage.getItem(`gradeSections_cache_${campusLC}`);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }
}

export async function saveGradeSections(campus, map) {
  const campusLC = String(campus || "").toLowerCase();
  if (!campusLC) return false;
  if (USE_LOCAL_FALLBACK) {
    localStorage.setItem("gradeSections", JSON.stringify(map || {}));
    return true;
  }
  // #region debug-point D:grade-sections-write
  dbg("D", "writing gradeSections", { docId: campusLC, keys: Object.keys(map || {}), useLocalFallback: USE_LOCAL_FALLBACK, projectId: db.app?.options?.projectId || "" });
  // #endregion
  await setDoc(doc(db, "gradeSections", campusLC), { campus: campusLC, map: map || {} }, { merge: true });
  try {
    localStorage.setItem(`gradeSections_cache_${campusLC}`, JSON.stringify(map || {}));
  } catch { /* ignore */ }
  return true;
}

export async function loadSectionAdvisers(campus) {
  const campusLC = String(campus || "").toLowerCase();
  if (!campusLC) return {};
  if (USE_LOCAL_FALLBACK) {
    try {
      const raw = localStorage.getItem("gradeSectionAdvisers");
      return raw ? JSON.parse(raw) : {};
    } catch { return {}; }
  }
  try {
    const snap = await getDoc(doc(db, "gradeSectionAdvisers", campusLC));
    const data = snap.exists() ? snap.data() : null;
    return (data && data.map) ? data.map : {};
  } catch { return {}; }
}

export async function saveSectionAdvisers(campus, map) {
  const campusLC = String(campus || "").toLowerCase();
  if (!campusLC) return false;
  if (USE_LOCAL_FALLBACK) {
    localStorage.setItem("gradeSectionAdvisers", JSON.stringify(map || {}));
    return true;
  }
  // #region debug-point D:advisers-write
  dbg("D", "writing gradeSectionAdvisers", { docId: campusLC, keys: Object.keys(map || {}), useLocalFallback: USE_LOCAL_FALLBACK, projectId: db.app?.options?.projectId || "" });
  // #endregion
  await setDoc(doc(db, "gradeSectionAdvisers", campusLC), { campus: campusLC, map: map || {} }, { merge: true });
  return true;
}
